module.exports = __webpack_public_path__ + "static/media/14UNEP27.22cb37f4.jpg";